(function () {
  'use strict';

  const revealEls = document.querySelectorAll('.reveal');

  function checkReveal() {
    const windowH = window.innerHeight;
    revealEls.forEach(function (el) {
      const top = el.getBoundingClientRect().top;
      if (top < windowH * 0.88) {
        el.classList.add('visible');
      }
    });
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  } else {
    window.addEventListener('scroll', checkReveal, { passive: true });
    checkReveal();
  }

  var navigation = document.querySelector('.navigation');
  if (navigation) {
    function syncNavigationOffset() {
      document.documentElement.style.setProperty(
        '--navigation-offset',
        navigation.offsetHeight + 'px'
      );
    }

    function toggleHeaderScroll() {
      if (window.scrollY > 50) {
        navigation.classList.add('is-scrolled');
      } else {
        navigation.classList.remove('is-scrolled');
      }
      syncNavigationOffset();
    }

    window.addEventListener('scroll', toggleHeaderScroll, { passive: true });
    window.addEventListener('resize', syncNavigationOffset);
    toggleHeaderScroll();
  }

  var hamburger = document.querySelector('.navigation-hamburger-button');
  var navLinks = document.querySelector('.navigation-menu-content');

  if (hamburger && navLinks) {
    hamburger.addEventListener('click', function () {
      var isOpen = hamburger.getAttribute('aria-expanded') === 'true';
      hamburger.setAttribute('aria-expanded', !isOpen);
      navLinks.classList.toggle('is-open');
      if (navigation) {
        requestAnimationFrame(function () {
          document.documentElement.style.setProperty(
            '--navigation-offset',
            navigation.offsetHeight + 'px'
          );
        });
      }
    });

    /* Close nav when a link is clicked */
    navLinks.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        navLinks.classList.remove('is-open');
        hamburger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* Navigation collapse toggle - collapses entire header */
  var collapseToggle = document.querySelector('.navigation-collapse-toggle');
  var navContent = document.querySelector('#navigation-content');

  if (collapseToggle && navContent) {
    collapseToggle.addEventListener('click', function () {
      var isExpanded = collapseToggle.getAttribute('aria-expanded') === 'true';
      collapseToggle.setAttribute('aria-expanded', !isExpanded);
      navContent.classList.toggle('collapsed');
      collapseToggle.title = isExpanded ? 'Expandir' : 'Recolher';
      if (navigation) {
        requestAnimationFrame(function () {
          document.documentElement.style.setProperty(
            '--navigation-offset',
            navigation.offsetHeight + 'px'
          );
        });
      }
    });
  }

  var contactForm = document.querySelector('.contact-form form');
  if (contactForm) {
    contactForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = contactForm.querySelector('.form-submit');
      if (!btn) return;
      var original = btn.textContent;
      btn.textContent = '✔ Message Sent!';
      btn.disabled = true;
      btn.style.background = '#16a34a';
      setTimeout(function () {
        btn.textContent = original;
        btn.disabled = false;
        btn.style.background = '';
        contactForm.reset();
      }, 3000);
    });
  }

  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        var navH = document.querySelector('.navigation')
          ? document.querySelector('.navigation').offsetHeight
          : document.querySelector('.site-header')
          ? document.querySelector('.site-header').offsetHeight
          : 0;
        window.scrollTo({
          top: target.offsetTop - navH,
          behavior: 'smooth'
        });
      }
    });
  });

  /* ---- Header Navigation Actions ---- */
  const scrollToTopBtn = document.getElementById('scroll-to-top');
  const scrollToBottomBtn = document.getElementById('scroll-to-bottom');

  if (scrollToTopBtn) {
    scrollToTopBtn.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }

  if (scrollToBottomBtn) {
    scrollToBottomBtn.addEventListener('click', function (e) {
      e.preventDefault();
      const footer = document.querySelector('footer');
      if (footer) {
        footer.scrollIntoView({
          behavior: 'smooth'
        });
      } else {
        window.scrollTo({
          top: document.documentElement.scrollHeight,
          behavior: 'smooth'
        });
      }
    });
  }

  setTimeout(function () {
    var vw = document.querySelector('[vw]');
    if (vw) {
      var s = document.createElement('script');
      s.src = 'https://vlibras.gov.br/app/vlibras-plugin.js';
      s.onload = function () {
        new window.VLibras.Widget('https://vlibras.gov.br/app');
      };
      document.body.appendChild(s);
    }
  }, 2000);

  /* ---- Mobile Navigation Logic ---- */
  const mobileHamburger = document.querySelector('.nav-mobile-hamburger');
  const mobileOverlay = document.querySelector('.nav-mobile-overlay');
  const mobileClose = document.querySelector('.nav-mobile-close');
  const mobileLinks = document.querySelectorAll('.nav-mobile-link');
  const mobileNav = document.querySelector('.navigation-mobile');

  if (mobileHamburger && mobileOverlay && mobileClose) {
    mobileHamburger.addEventListener('click', () => {
      mobileOverlay.classList.add('is-active');
      document.body.style.overflow = 'hidden'; // Prevent scroll when menu is open
    });

    mobileClose.addEventListener('click', () => {
      mobileOverlay.classList.remove('is-active');
      document.body.style.overflow = '';
    });

    mobileLinks.forEach(link => {
      link.addEventListener('click', () => {
        mobileOverlay.classList.remove('is-active');
        document.body.style.overflow = '';
      });
    });
  }

  /* Mobile scroll effect */
  if (mobileNav) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 20) {
        mobileNav.classList.add('is-scrolled');
      } else {
        mobileNav.classList.remove('is-scrolled');
      }
    }, { passive: true });
  }

})();
